import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureTableTag = ({
  children,
  textColor,
  backgroundColor,
  borderColor
}) => {
  const hasBorder = !!borderColor;
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: backgroundColor,
    alignSelf: "stretch",
    marginInline: "-400",
    borderStartStartRadius: "100",
    borderStartEndRadius: "100",
    borderColor: borderColor,
    borderStyle: hasBorder ? 'solid' : 'none',
    borderWidth: hasBorder ? '200' : '0',
    paddingBlock: hasBorder ? '50' : '100',
    children: /*#__PURE__*/_jsx(Text, {
      color: textColor,
      typography: "detail-100",
      paddingBlock: "100",
      textAlign: "center",
      children: children
    })
  });
};